// utils/teamTypeUtils.js

export const environmentConfig = {
  office: {
    icon: '🏢',
    label: 'Office / Corporate',
    className: 'team-type-office',
    color: '#1976d2'
  },
  candidate: {
    icon: '👥',
    label: 'Candidate Hiring',
    className: 'team-type-candidate',
    color: '#7b1fa2'
  },
  employee: {
    icon: '👔',
    label: 'Employee Workforce',
    className: 'team-type-employee',
    color: '#1565c0'
  },
  student: {
    icon: '🎓',
    label: 'Student Career / College',
    className: 'team-type-student',
    color: '#00838f'
  },
  military: {
    icon: '🎖️',
    label: 'Military Readiness',
    className: 'team-type-military',
    color: '#c62828'
  },
  healthcare: {
    icon: '🏥',
    label: 'Healthcare Clinical Fit',
    className: 'team-type-healthcare',
    color: '#ad1457'
  },
  government: {
    icon: '🏛️',
    label: 'Government Public Service',
    className: 'team-type-government',
    color: '#5d4037'
  },
  executive: {
    icon: '👑',
    label: 'Executive Leadership',
    className: 'team-type-executive',
    color: '#6a1b9a'
  },
  custom: {
    icon: '✨',
    label: 'Custom',
    className: 'team-type-custom',
    color: '#667eea'
  }
};

export const formatTeamLabel = (value) => {
  if (!value) return '';

  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
};

export const getTeamTypeDisplay = (team) => {
  if (!team) return null;

  const environment = team.environment || team.team_type || 'office';
  const config = environmentConfig[environment] || environmentConfig.custom;

  if (environment === 'custom' && team.custom_type) {
    return {
      icon: config.icon,
      text: team.custom_type,
      typeText: team.custom_type,
      subtypeText: '',
      flowText: 'Custom',
      className: config.className,
      color: config.color,
      fullDisplay: `${config.icon} ${team.custom_type}`
    };
  }

  const typeText = formatTeamLabel(team.team_type);
  const subtypeText = formatTeamLabel(team.team_subtype);
  const flowText = formatTeamLabel(team.assessment_flow);

  return {
    icon: config.icon,
    text: config.label,
    typeText,
    subtypeText,
    flowText,
    className: config.className,
    color: config.color,
    fullDisplay: `${config.icon} ${config.label}`,
    detailedDisplay: [config.label, typeText, subtypeText].filter(Boolean).join(' • ')
  };
};

export const getTeamTypeBadgeClass = (environment) => {
  const config = environmentConfig[environment] || environmentConfig.custom;
  return config.className;
};

export const getTeamTypeColor = (environment) => {
  const config = environmentConfig[environment] || environmentConfig.custom;
  return config.color;
};